import { Autocomplete, Chip, TextField } from '@mui/material';
import React from 'react';

/**
 * CP-8335: assign a knowledge-base document or a trigger reply to some of the operator's web
 * widgets. Empty = not assigned: every widget that uses shared items gets it (a widget set to
 * "only its own items" never does). Shown only to operators with several widgets.
 */
export const widgetLabel = (w) => (w ? (w.display_name || w.name) : '');

/** Widget ids a newly created item gets: none on the main shared widget, else the widget on
 * screen (so a document added while editing Signature Edition never reaches the other sites). */
export const defaultWidgetIdsFor = (widgets, widget) => {
  if (!widget || !widgets || widgets.length < 2) return [];
  if (widget.is_default && widget.knowledge_mode !== 'isolated') return [];
  return [widget.id];
};

const WidgetsPicker = ({ widgets, value, onChange, disabled, sx }) => (
  <Autocomplete
    multiple
    size="small"
    disabled={disabled}
    options={widgets || []}
    value={value || []}
    onChange={(e, v) => onChange((v || []).map(({ id, key, name, display_name: displayName }) => ({
      id, key, name: displayName || name,
    })))}
    getOptionLabel={widgetLabel}
    isOptionEqualToValue={(a, b) => a.id === b.id}
    renderTags={(tags, getTagProps) => tags.map((option, index) => (
      <Chip {...getTagProps({ index })} label={widgetLabel(option)} size="small" color="primary" variant="outlined" />
    ))}
    renderInput={(params) => (
      <TextField
        {...params}
        label="Widgets"
        helperText="Leave empty to share with every widget"
        inputProps={{ ...params.inputProps, 'aria-label': 'Widgets' }}
        sx={{ backgroundColor: 'white', '& .MuiFormLabel-root': { fontSize: 12 } }}
      />
    )}
    sx={{ width: '100%', mb: 1, ...(sx || {}) }}
  />
);

export default WidgetsPicker;
